<template>
  <div>
    <h1>Strony opisowe</h1>
    <v-row>
      <v-spacer />
      <v-btn class="success" @click="$router.push('/settings/custom-webpage/edit/new')">{{ $t("settings.customWebpage.newButton") }}</v-btn>
    </v-row>
    <v-data-table :items="customWebpages" :headers="headers">
      <template #item="props">
        <tr>
          <td>
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :disabled="props.item.order_number === 1" @click="moveUp(props.item)" icon v-on="on">
                  <v-icon>fa-arrow-alt-circle-up</v-icon>
                </v-btn>
              </template>
              {{ $t("global.moveUp") }}
            </v-tooltip>

            {{ props.item.order_number }}
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :disabled="props.item.order_number === customWebpages.length" @click="moveDown(props.item)" icon v-on="on">
                  <v-icon>fa-arrow-alt-circle-down</v-icon>
                </v-btn>
              </template>
              {{ $t("global.moveDown") }}
            </v-tooltip>
          </td>
          <td>
            <v-icon>{{ props.item.icon }}</v-icon>
            {{ props.item.icon }}
          </td>
          <td>
            {{ props.item.alias }}
          </td>
          <td>
            {{ props.item.title }}
          </td>
          <td class="text-center">
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn :to="'/settings/custom-webpage/edit/' + props.item.id" icon v-on="on">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn @click.native="remove(props.item)" icon v-on="on"><v-icon>delete</v-icon></v-btn>
              </template>
              {{ $t("global.delete") }}
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "SettingsCustomWebpageView",
  data: () => ({
    customWebpages: []
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("settings.customWebpage.headers.order"),
          value: "order_number"
        },
        {
          text: this.$t("settings.customWebpage.icon"),
          value: "icon"
        },
        {
          text: this.$t("settings.customWebpage.headers.alias"),
          value: "alias"
        },
        {
          text: this.$t("settings.customWebpage.headers.title"),
          value: "title"
        },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  methods: {
    moveUp(item) {
      this.axios.post("settings/custom-webpage/move-up", { id: item.id }).then(() => {
        this.getList();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },
    moveDown(item) {
      this.axios.post("settings/custom-webpage/move-down", { id: item.id }).then(() => {
        this.getList();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },
    remove(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result
        .then(() => {
          this.axios.post("settings/custom-webpage/delete", { id: item.id }).then(() => {
            this.getList();
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.removedItem"),
              position: "down"
            });
          });
        })
        .catch(function() {});
    },
    getList() {
      this.axios.get("custom-webpage/get-list").then(resp => {
        this.customWebpages = resp.data;
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style scoped></style>
